import { AxiosResponse } from 'axios';

import { QueryObserverOptions, useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useFindId */
export type TypeFindIdParams = {
  /** 휴대전화번호 */
  phoneNumber: string;
  /** 인증번호 */
  verificationCode: string;
};

/** @category useFindId */
export type TypeFindIdResponse = {
  code: string;
  message: string;
  data: {
    /** 로그인 아이디 */
    username: string;
  };
};

/**
 * @description 인증번호를 통해 아이디를 찾는 api 요청에 사용되는 커스텀 훅
 */
export const useFindId = () => {
  const queryClient = useQueryClient();
  const trigger = async ({
    params,
    onSuccess,
    onError,
    queryConfig,
  }: {
    params: TypeFindIdParams;
    onSuccess?: (data: TypeFindIdResponse) => void;
    onError?: (error: TypeErrorFormat) => void;
    queryConfig?: Omit<QueryObserverOptions<AxiosResponse<TypeFindIdResponse>>, 'queryKey' | 'queryFn'>;
  }) => {
    const endpoint = '/labor-accounts/find-username';

    const query = queryClient.ensureQueryData<AxiosResponse<TypeFindIdResponse>>({
      queryKey: ['labor-accounts', 'find-id', params.phoneNumber, params.verificationCode],
      queryFn: () => axiosInstance.get<TypeFindIdResponse>(endpoint, { params, headers: { withoutToken: true } }),
      ...queryConfig,
    });

    return requestHelper(() => query, onSuccess, onError);
  };

  return trigger;
};
